/* tslint:disable */
/* eslint-disable */
/**
 * Main API v1.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { FcbVisiteGridDto } from './FcbVisiteGridDto';
import {
    FcbVisiteGridDtoFromJSON,
    FcbVisiteGridDtoFromJSONTyped,
    FcbVisiteGridDtoToJSON,
} from './FcbVisiteGridDto';
import type { IAggregateResult } from './IAggregateResult';
import {
    IAggregateResultFromJSON,
    IAggregateResultFromJSONTyped,
    IAggregateResultToJSON,
} from './IAggregateResult';

/**
 * 
 * @export
 * @interface FcbVisiteGridDtoPaginatedResults
 */
export interface FcbVisiteGridDtoPaginatedResults {
    /**
     * 
     * @type {number}
     * @memberof FcbVisiteGridDtoPaginatedResults
     */
    totalCount?: number;
    /**
     * 
     * @type {Array<FcbVisiteGridDto>}
     * @memberof FcbVisiteGridDtoPaginatedResults
     */
    results?: Array<FcbVisiteGridDto> | null;
    /**
     * 
     * @type {Array<IAggregateResult>}
     * @memberof FcbVisiteGridDtoPaginatedResults
     */
    aggregateResults?: Array<IAggregateResult> | null;
}

/**
 * Check if a given object implements the FcbVisiteGridDtoPaginatedResults interface.
 */
export function instanceOfFcbVisiteGridDtoPaginatedResults(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function FcbVisiteGridDtoPaginatedResultsFromJSON(json: any): FcbVisiteGridDtoPaginatedResults {
    return FcbVisiteGridDtoPaginatedResultsFromJSONTyped(json, false);
}

export function FcbVisiteGridDtoPaginatedResultsFromJSONTyped(json: any, ignoreDiscriminator: boolean): FcbVisiteGridDtoPaginatedResults {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'totalCount': !exists(json, 'totalCount') ? undefined : json['totalCount'],
        'results': !exists(json, 'results') ? undefined : (json['results'] === null ? null : (json['results'] as Array<any>).map(FcbVisiteGridDtoFromJSON)),
        'aggregateResults': !exists(json, 'aggregateResults') ? undefined : (json['aggregateResults'] === null ? null : (json['aggregateResults'] as Array<any>).map(IAggregateResultFromJSON)),
    };
}

export function FcbVisiteGridDtoPaginatedResultsToJSON(value?: FcbVisiteGridDtoPaginatedResults | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'totalCount': value.totalCount,
        'results': value.results === undefined ? undefined : (value.results === null ? null : (value.results as Array<any>).map(FcbVisiteGridDtoToJSON)),
        'aggregateResults': value.aggregateResults === undefined ? undefined : (value.aggregateResults === null ? null : (value.aggregateResults as Array<any>).map(IAggregateResultToJSON)),
    };
}

